import React from 'react';
const points = ['😩 Improwizacja: Przychodzisz na trening bez jasnego planu, a zawodnicy to widzą.', '📉 Brak Postępów: Twoja grupa stoi w miejscu, bo nie masz zaplanowanej progresji z tygodnia na tydzień.', '🔄 Stagnacja: W kółko powtarzasz te same 10 ćwiczeń, bo nie masz czasu na nowe materiały.', '💼 Aspiracja: Chcesz być postrzegany jako nowoczesny trener, a nie ktoś, kto „rzuca piłkę i czeka, aż samo się ugra".', 'Rozpoznałeś się w 2 lub więcej? Zatem ten zestaw powstał dla Ciebie.'];
export function ForWhomSection() {
  return <section className="w-full bg-bg-dark py-20 px-4 relative overflow-hidden" data-id="element-119">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(37,99,235,0.08) 0%, transparent 70%)'
    }} data-id="element-120"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-121">
        <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-12 text-center tracking-tight" data-id="element-122">
          👀 To jest dla Ciebie, jeśli…
        </h2>

        <div className="space-y-4" data-id="element-123">
          {points.map((point, i) => <div key={i} className="flex items-start gap-5 bg-bg-alt rounded-2xl p-6 border border-border-light hover:border-primary/50 transition-colors group" data-id="element-124">
              <div className="w-8 h-8 rounded-full bg-check-green/20 flex items-center justify-center flex-shrink-0 mt-0.5 border border-check-green/30 group-hover:bg-check-green group-hover:border-check-green transition-colors shadow-[0_0_10px_rgba(16,185,129,0.2)]" data-id="element-125">
                <span className="text-check-green group-hover:text-white text-sm font-bold transition-colors" data-id="element-126">
                  ✓
                </span>
              </div>
              <p className="text-text-main text-lg font-medium leading-relaxed" data-id="element-127">
                {point}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}